<template>
  <!-- Footer -->
  <div
    class="bg-surface-50 mt-auto h-full w-full flex-col items-end justify-center p-4 px-8 text-sm backdrop-blur"
  >
    <div
      class="mb-4 flex w-full flex-wrap items-center justify-center gap-6 pb-4 md:gap-8"
    >
      <img
        v-for="logo in FOOTER_LOGOS"
        :key="logo.url"
        :src="logo.url"
        :alt="logo.alt"
        :width="logo.width"
        :height="logo.height"
        class="object-contain"
      />
    </div>

    <div
      class="flex w-full flex-wrap-reverse items-center justify-between gap-x-10 gap-y-2 text-nowrap"
    >
      <div class="flex items-center gap-4">
        <!-- No copyright line (Kelvin, 2026-10-14). -->
        <FooterDevDashboard />
      </div>

      <div class="flex gap-3 font-medium">
        <a
          class="hover:text-primary cursor-pointer transition-colors duration-200"
          @click="handleContactUs"
        >
          {{ t('siteFooter.contactUs') }}
        </a>
        <router-link
          to="/eula#information"
          class="hover:text-primary transition-colors duration-200"
        >
          {{ t('siteFooter.privacyPolicy') }}
        </router-link>
        <router-link
          to="/eula"
          class="hover:text-primary transition-colors duration-200"
        >
          {{ t('siteFooter.termsOfService') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import FooterDevDashboard from '@/components/_dev/FooterDevDashboard.vue';
import { FOOTER_LOGOS } from '@/constants/branding';

const router = useRouter();
const { t } = useI18n();

const handleContactUs = () => {
  router.push('/contact');
};
</script>
